import { createRouter, createWebHashHistory } from 'vue-router'
import store from '@/store';
const Login = () => import(/* webpackChunkName: "login-chunk" */ '@/views/LoginView.vue');
const Default = () => import(/* webpackChunkName: "default-chunk" */ '@/views/DefaultView.vue');
const Home = () => import(/* webpackChunkName: "home-chunk" */ '@/views/HomeView.vue');
//const RecuperoPassword = () => import(/* webpackChunkName: "recPsw-chunk" */ '@/views/RecuperoPasswordView.vue');
const CataloghiView = () => import(/* webpackChunkName: "Catalogo-chunk" */ '@/views/CataloghiView.vue');
const Clienti = () => import(/* webpackChunkName: "Clienti-chunk" */ '@/views/ClientiView.vue');
const SchedaCliente = () => import(/* webpackChunkName: "SchedaCliente-chunk" */ '@/views/SchedaClienteView.vue');
const SchedaOrdine = () => import(/* webpackChunkName: "SchedaOrdine-chunk" */ '@/views/SchedaOrdineView');
const Ordini = () => import(/* webpackChunkName: "Ordini-chunk" */ '@/views/OrdiniView');
const SchedaProdotto = () => import(/* webpackChunkName: "SchedaProdotto-chunk" */ '@/views/SchedaArticoloView');
const Scadenzario = () => import(/* webpackChunkName: "Scadenzario-chunk" */ '@/views/ScadenzeView');
const StoricoOrdiniCliente = () => import(/* webpackChunkName: "StoricoOrdiniCliente-chunk" */ '@/views/StoricoOrdiniClienteView');
const SchedaCatalogoView = () => import(/* webpackChunkName: "SchedaCatalogoView-chunk" */ '@/views/SchedaCatalogoView');
const PageView = () => import(/* webpackChunkName: "PageView-chunk" */ '@/views/PageView');
const OrderForm = () => import(/*webpackChunkName: "OrderForm-chunk"*/ "@/views/OrderFormView");
const Fatture = () => import(/*webpackChunkName: "Fatture-chunk"*/ "@/views/FattureView");
const SchedaFattura = () => import(/*webpackChunkName: "SchedaFattura-chunk"*/ "@/views/SchedaFatturaView");
const SchedaDocumenti = () => import(/*webpackChunkName: "SchedaDocumenti-chunk"*/ "@/views/SchedaDocumentiView");

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  /*{
    path: '/PasswordRecovery',
    name: 'RecuperoPassword',
    component: RecuperoPassword
  },*/
  {
    path: '/default',
    name: "Default",
    component: Default,
    beforeEnter(to, from, next){
      if(store.getters.isLoggedIn){
        next();
      }
      else{
        next('/');
      }
    },
    children:[
      {
        path: '',
        name: "Home",
        component: Home,
        meta: {
          breadCrumbs:[
            {
              to: '/',
              text: 'HomepageArianna'
            }
          ]
        },
      },
      {
        path: '/catalogs',
        name: "CataloghiView",
        component: CataloghiView,
        meta: {
          breadCrumbs:[
            {
              to: '/default',
              text: 'HomepageArianna'
            },
            {
              to: '/catalogo',
              text: 'CatalogArianna'
            }
          ]
        },
      },
      {
        path: '/customers',
        name: "Clienti",
        component: Clienti,
        meta: {
          breadCrumbs:[
            {
              to: '/default',
              text: 'HomepageArianna'
            },
            {
              to: '/clienti',
              text: 'CatalogArianna'
            }
          ]
        },
      },
      {
        path: 'customers/:clientCode',
        name: "SchedaCliente",
        component: SchedaCliente,
        meta: {
          breadCrumbs:[
            {
              to: '/default',
              text: 'HomepageArianna'
            },
            {
              to: '/SchedaClienti',
              text: 'RestockCatalogArianna'
            }
          ]
        }
      },
      {
        path: '/orders/:IdOrdine',
        name: "Ordine",
        component: SchedaOrdine,
        meta: {
          breadCrumbs:[
            {
              to: '/default',
              text: 'HomepageArianna'
            }
          ]
        },
      },
      {
        path: '/orders',
        name: "Ordini",
        component: Ordini,
        meta: {
          breadCrumbs:[
            {
              to: '/default',
              text: 'HomepageArianna'
            }
          ]
        },
      },
      {
        path: '/products/:IdProduct',
        name: "SchedaProdotto",
        component: SchedaProdotto,
        meta: {
          breadCrumbs:[
            {
              to: '/default',
              text: 'HomepageArianna'
            }
          ]
        },
      },
      {
        path: '/deadlines',
        name: "Scadenzario",
        component: Scadenzario,
        meta: {
          breadCrumbs:[
            {
              to: '/default',
              text: 'HomepageArianna'
            }
          ]
        },
      },
      {
        path: '/OrdersHistory/:customerCode',
        name: "StoricoOrdiniCliente",
        component: StoricoOrdiniCliente,
        meta: {
          breadCrumbs:[
            {
              to: '/default',
              text: 'HomepageArianna'
            }
          ]
        },
      },
      {
        path: '/Catalogs/:CatalogId',
        name: "SchedaCatalogoView",
        component: SchedaCatalogoView,
        meta: {
          breadCrumbs:[
            {
              to: '/default',
              text: 'HomepageArianna'
            }
          ]
        }
      },{
        path: "pages/:permalink",
        name: "Pages",
        component: PageView,
        meta: {
          breadCrumbs: [{
            to: '/',
            text: 'Home' 
          },
          {
            to: '',
            text: ''
          }
        ]
        }
      },{
				path: "orderForm/:IdOrdine",
				name: "orderForm",
				component: OrderForm,
				meta: {
					breadCrumbs: [
						{
							to: '/',          
							text: 'Home' 
						},
						{
							to: '',
							text: ''
						}         
					]
				}
			},
      {
				path: "/bills",
				name: "Fatture",
				component: Fatture,
				meta: {
					breadCrumbs: [
						{
							to: '/',          
							text: 'Home' 
						},
						{
							to: '',
							text: ''
						}         
					]
				}
			},
      {
				path: "/bills/:idDoc",
				name: "SchedaFattura",
				component: SchedaFattura,
				meta: {
					breadCrumbs: [
						{
							to: '/',          
							text: 'Home' 
						},
						{
							to: '',
							text: ''
						}         
					]
				}
			},
      {
				path: "/documents/:customerCode",
				name: "SchedaDocumenti",
				component: SchedaDocumenti,
				meta: {
					breadCrumbs: [
						{
							to: '/',          
							text: 'Home' 
						},
						{
							to: '',
							text: ''
						}         
					]
				}
			}
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
